import { axiosInstance } from "@/use/utilities/axios/app/axios-instance";
import {axiosInstanceWithoutLoader} from "@/use/utilities/axios/app/axios-instance-without-loader";

/**
 * Fetch all laboratory assets from the backend.
 *
 * @param {Object} params - Query parameters to filter the assets.
 * @param {number} [params.prescription_test_id] - Filter by prescription test ID.
 * @param {string} params.action - Required. One of:
 *   - 'by_states'
 *   - 'by_states_digital'
 *   - 'by_states_and_material'
 *   - 'by_prescription'
 *   - 'by_prescription_test'
 *
 * @param {boolean} [loading=true] - Whether to show the loading spinner (uses axios instance with loader).
 *
 * @returns {Promise<{ assets: Array }>} - Returns a list of filtered assets.
 *
 * @throws {Array<string>} - Throws backend validation or server errors.
 */
export async function fetchAll(params, loading = true) {
  const axios = loading ? axiosInstance().primoLab : axiosInstanceWithoutLoader().primoLab;
  let assets = [];

  await axios
    .get("/assets", { params })
    .then(async (response) => {
      assets = response.data.data;
    })
    .catch(async (error) => {
      throw error.response.data.errors;
    });

  return { assets };
}
